import React from 'react';
import { Template, INLINE_TIPS } from '../lib/data';
import { TemplateCard } from './TemplateCard';
import { LightbulbIcon } from 'lucide-react';
interface TemplateGridProps {
  templates: Template[];
}
export function TemplateGrid({
  templates
}: TemplateGridProps) {
  if (templates.length === 0) {
    return <div className="text-center py-20 border-2 border-dashed border-border rounded-xl" data-id="element-196">
        <h3 className="text-lg font-medium text-foreground" data-id="element-197">
          No templates found
        </h3>
        <p className="text-muted-foreground mt-1" data-id="element-198">
          Try adjusting your filters or search query.
        </p>
      </div>;
  }
  // Function to inject tips between rows
  const renderGridWithTips = () => {
    const elements = [];
    const itemsPerRow = 3; // Assuming 3 cols on desktop
    for (let i = 0; i < templates.length; i++) {
      elements.push(<div key={templates[i].id} data-id="element-199">
          <TemplateCard template={templates[i]} data-id="element-200" />
        </div>);
      // Inject a tip after every 6th item (2 rows), if there are more items to come
      if ((i + 1) % 6 === 0 && i !== templates.length - 1) {
        const tipIndex = ((i + 1) / 6 - 1) % INLINE_TIPS.length;
        elements.push(<div key={`tip-${i}`} className="col-span-1 md:col-span-2 lg:col-span-3 py-4" data-id="element-201">
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-start gap-3 shadow-sm" data-id="element-202">
              <div className="p-2 bg-amber-100 text-amber-600 rounded-full flex-shrink-0" data-id="element-203">
                <LightbulbIcon className="w-5 h-5" data-id="element-204" />
              </div>
              <div data-id="element-205">
                <h4 className="font-semibold text-amber-800 text-sm mb-1" data-id="element-206">
                  Strategy Tip
                </h4>
                <p className="text-amber-700 text-sm" data-id="element-207">
                  {INLINE_TIPS[tipIndex]}
                </p>
              </div>
            </div>
          </div>);
      }
    }
    return elements;
  };
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-208">
      {renderGridWithTips()}
    </div>;
}